import { FINANCE } from 'consts';

export const STATUS_NEW = -1;
export const STATUS_APPROVED = 0;
export const STATUS_PENDING = 1;
export const STATUS_PROCESSING = 2;
export const STATUS_ERROR = 3;
export const STATUS_REJECTED = 4;
export const STATUS_MORE_INFO = 5;
export const STATUS_DELETED = 6;

export const STATUS_COLOR_MAP = new Map([
  [STATUS_NEW, 'inactive'],
  [STATUS_APPROVED, 'success'],
  [STATUS_PENDING, 'processing'],
  [STATUS_PROCESSING, 'processing'],
  [STATUS_ERROR, 'danger'],
  [STATUS_REJECTED, 'danger'],
  [STATUS_MORE_INFO, 'info'],
  [STATUS_DELETED, 'inactive'],
]);

export const TAB_DETAILS = 'details';
export const TAB_ACTIONS_LOG = 'actions-logs';

export const getRoute = (id: number) => {
  return `/${FINANCE}/sa/${id}/${TAB_DETAILS}`;
};

export const ACTION_APPROVE = 'approve';
export const ACTION_REJECT = 'reject';
export const ACTION_MORE_INFO = 'more_info';
export const ACTION_UNDO = 'undo';
